import { render, staticRenderFns } from "./flowTable.vue?vue&type=template&id=1ee5a8e1&"
import script from "./flowTable.vue?vue&type=script&lang=js&"
export * from "./flowTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports